export default "__VITE_ASSET__6fbd94c4__"